// @flow

export const RESIZE = 'window/resize';
export const SCROLL = 'window/scroll';



// WEBPACK FOOTER //
// ./shared/state/actions/window.js